import React from 'react'
import { MapPin, Phone, Mail } from 'lucide-react'
import Reveal from '../components/Reveal'

const IconFacebook = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
  </svg>
)
const IconYoutube = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
    <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46a2.78 2.78 0 0 0-1.95 1.96A29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58a2.78 2.78 0 0 0 1.95 1.95C5.12 20 12 20 12 20s6.88 0 8.59-.47a2.78 2.78 0 0 0 1.95-1.95A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"/>
    <polygon fill="white" points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02"/>
  </svg>
)

export default function ContactInfo({ info, mapUrl }) {
  const details = [
    { icon: MapPin, label: 'Address', value: info.address ?? '18 Tran Hung Dao, Hoan Kiem, Hanoi' },
    { icon: Phone,  label: 'Hotline', value: info.phone   ?? '+84 (0) 123 456 789', href: `tel:${info.phone ?? ''}` },
    { icon: Mail,   label: 'Email',   value: info.email   ?? 'booking@lejourney.vn', href: `mailto:${info.email ?? ''}` },
  ]

  const socials = [
    { icon: IconFacebook, href: info.facebook ?? '#', label: 'Facebook' },
    { icon: IconYoutube,  href: info.youtube  ?? '#', label: 'YouTube' },
  ]

  return (
    <Reveal variant="fade-right" threshold={0.1} className="cp-info">
      <p className="cp-info__lead">
        {info.description ?? "We're here to help you plan the perfect voyage. Reach out to our team for reservations, itinerary advice, or any questions about life on board."}
      </p>

      <div className="cp-details">
        {details.map(({ icon: Icon, label, value, href }) => (
          <div key={label} className="cp-detail">
            <div className="cp-detail__icon">
              <Icon size={15} strokeWidth={1.5} />
            </div>
            <div className="cp-detail__content">
              <span className="cp-detail__label">{label}</span>
              <span className="cp-detail__value">
                {href ? <a href={href}>{value}</a> : value}
              </span>
            </div>
          </div>
        ))}
      </div>

      <div className="cp-socials">
        {socials.map(({ icon: Icon, href, label }) => (
          <a key={label} href={href} className="cp-social" aria-label={label} target="_blank" rel="noreferrer">
            <Icon />
          </a>
        ))}
      </div>

      <div className="cp-map">
        {mapUrl ? (
          <iframe src={mapUrl} allowFullScreen loading="lazy" title="Office location" />
        ) : (
          <div className="cp-map__placeholder">
            <MapPin size={32} strokeWidth={1} />
            <span>Map coming soon</span>
          </div>
        )}
      </div>
    </Reveal>
  )
}
